<p>createnewmasterkeyuser works!</p>
